import { inject, Injectable, Injector } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StoreService } from '../store.service';
import { JurisdictionsService } from './general-settings/jurisdictions.service';
import { LawsService } from './general-settings/laws.service';
import { RegulationsService } from './general-settings/regulations.service';
import ApiOptionsConfig from './api-options.config';

const BASE_URL = '/projects';
const BASE_URL_CHECKLIST = '/checklists';
const BASE_URL_CHECKLIST_GROUP = '/checklist-groups';
const BASE_URL_TESTLIST = '/testlists';

const params = new HttpParams().set('size', '9999');
@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  accessToken: string = '';

  storeService: StoreService;
  httpClient: HttpClient;


  private projectSettings = {
    checklist: [{
      checklistId: 1,
      jurisdiction: 'Malta',
      jurisdictionId: 2,
      law: 'System Audit Checklist - 08/2018',
      law_id: 6,
      name: 'Checklist MT - System Audit - Rev2',
      details: 'MGA System Audit',
      createTime: '2023-10-01T12:00:00Z',
      regulation: [
        {
          id: 1,
          law: 'RESDI-2020-12-GCABA-LOTBA - Especificaciones tecnicas de juego, trazabilidad y transparencia',
          jurisdiction: 'Malta',
          title: "1.1.1. System Architecture",
          description: "El Generador de Números Aleatorios deberá cumplir, como mínimo, los siguientes requisitos: ● Los datos aleatorios generados deben ser estadísticamente independientes.",
          category: "Live Games - Information",
          badge: [{ key: 'MT_SYSTEM_AUDIT', value: 'MY SYSTEM AUDIT' }],
        }]
    },
    {
      checklistId: 2,
      jurisdiction: 'Spain',
      jurisdictionId: 19,
      law: 'BOE-A-2014-10302 (RES_TEC)',
      law_id: 16,
      name: 'Checklist SPA - Security - Rev0',
      details: 'Checklist SPA - Security - Rev0',
      createTime: '2024-08-16T19:50:00Z',
    }],
    testlists: [
      {
        testlist_id: 903,
        name: "1. Requirements",
        jurisdiction: 'Spain',
        estimated_time: 61,
        test_procedure: null,
        create_time: "2021-07-28 11:27:17",
        __errors: [],
        testlistJoinRegulationList:
        {
          testlist_id: 903,
          checklist_id: 61,
          regulation_id: 1322,
          __errors: [],
          checklist: {
            checklist_id: 61,
            jurisdiction_id: 19,
            name: "Checklist SPA - Security - Rev0",
            details: "Checklist SPA - Security - Rev0",
            create_time: "2021-07-28 11:16:15",
            __errors: [],
            checklistJoinRegulationList: [
              {
                checklist_id: 61,
                regulation_id: 1441,
                __errors: [],
                regulation: {
                  regulation_id: 1441,
                  jurisdiction_id: 19,
                  law_id: 24,
                  article_title: "Anexo VII - Requisitos técnicos de seguridad -  a) Politicas de Seguridad - Point 1",
                  article_details: "De conformidad con el apartado 4.4 del Anexo I de la Resolución de 6 de octubre de 2014, de la Dirección General de Ordenación del Juego, por la que se aprueba la disposición por la que se desarrollan las especificaciones técnicas de juego, trazabilidad y seguridad que deben cumplir los sistemas técnicos de juego de carácter no reservado objeto de licencias otorgadas al amparo de la ley 13/2011, de 27 de mayo, de regulación del juego, la entidad de certificación deberá verificar que:\r\n1. El operador dispone de procedimientos de seguridad.",
                  create_time: "2021-09-06 09:29:42",
                  __errors: [],
                  categoryList: [
                    {
                      category_id: 86,
                      code: "SPA - Security",
                      name: "SPA - Security",
                      create_time: "2021-07-28 11:11:36",
                      __errors: []
                    }
                  ]
                }
              },
            ]
          },
          regulation: {
            regulation_id: 1322,
            jurisdiction_id: 19,
            law_id: 16,
            article_title: "4. Seguridad de los Sistemas de Información - 4.17 Test de penetración y Análisis de vulnerabilidades",
            article_details: "The game system shall\r\npass a penetration test and vulnerability scan, at least regularly\r\nannual. The technical systems or part of them for informational purposes only,\r\nwhere no bets are made and there is no access to the user registration or account\r\ngame, will be exempt from the obligation to perform penetration tests and analysis of\r\nvulnerabilities.\r\nThe technical systems in which the interaction with the player is by telephone or\r\nby SMS they will also be exempt from this obligation.\r\nThe penetration test and vulnerability analysis may be carried out by\r\nentities other than entities designated for security assessment, or\r\neven be carried out with the operator's own resources in the case of having the\r\nappropriate means.\r\nThe penetration test will consist of a method of evaluating the safety of a\r\nnetwork or a system, by simulating an attack carried out by a third party. The\r\nprocess includes an active analysis of the system looking for weaknesses, technical failures, or\r\nvulnerabilities. The test will include all public interfaces that guard, process or\r\ntransmit personal, financial or gaming data.\r\nThe vulnerability analysis will consist of the passive identification and quantification of\r\nthe potential risks of the system. The analysis will include all the components that\r\nsafeguard, process or transmit personal, economic or gaming data.\r\nThe results of the tests and analyzes should be kept together with the measurements\r\napplied or planned corrective measures, for later review or inspection.\r\nBefore the start of the game commercialization, the technical system must have\r\nsuccessfully passed both a penetration test and a vulnerability scan. The\r\nscope and results must be evaluated by one of the entities designated to\r\nsecurity certification during the certification process.\r\nIn the event that a security failure is detected as a result of the test or analysis\r\nvery serious, which could put at risk the identity or financial situation of the\r\nplayers or allow their impersonation, the operator will immediately notify the\r\nDGOJ together with the action plan that it had defined. The DGOJ may require the\r\nsuspension of the affected gambling offer until the ruling is corrected.\r\nIn the face of less serious security incidents, the operator will adopt a plan of\r\nimprovement and in the next test or analysis will include in the scope the verification of the adequate\r\ncorrection of previously detected incidents.\r\nThe operator must keep the complete report of each test or analysis performed\r\nfor at least four years",
            create_time: "2021-07-28 11:14:56",
            __errors: [],
            categoryList: [
              {
                category_id: 86,
                code: "SPA - Security",
                name: "SPA - Security",
                create_time: "2021-07-28 11:11:36",
                __errors: []
              }
            ]
          }
        },
        rules: [
          {
            id: 'RTS-7A',
            title: 'RTS requirement 7A',
            content: 'Random number generation and game results must be "acceptably random". Acceptably random here means that it is possible to demonstrate to a high degree of confidence that the output of the RNG, game, lottery and virtual event outcomes are random through, for example, statistical analysis using generally accepted tests and methods of analysis. Adaptive behaviour (i.e a compensated game) is not permitted. Where lotteries use the outcome of other events external to the lottery to determine the result of the lottery the outcome must be unpredictable and externally verifiable.',
            expanded: false
          },
          {
            id: 'RTS-7B',
            title: 'RTS requirement 7B',
            content: 'Additional requirements for RTS 7B implementation and verification procedures.',
            expanded: false
          },
          {
            id: 'RTS-7A-d',
            title: 'RTS Implementation 7A.d',
            content: 'Specific implementation guidance for requirement 7A subsection d.',
            expanded: false
          },
          {
            id: 'RTS-7B-guidance',
            title: 'RTS implementation guidance 7B',
            content: 'Detailed implementation guidance for RTS requirement 7B compliance verification.',
            expanded: false
          }
        ],
        reviewConfirmed: false,
        testlistStepList: [
          {
            testlist_step_id: 4148,
            testlist_id: 903,
            type: "without_evidence",
            text: "1.1\tVerify compliance with the requirements described in the regulation.",
            position: 1,
            create_time: "2021-07-28 11:27:17",
            __errors: []
          },
          {
            testlist_step_id: 4149,
            testlist_id: 903,
            type: "with_evidence",
            text: "2 Verification with evidence collection (Once the verification without evidence, find no errors)",
            position: 1,
            create_time: "2021-07-28 11:27:17",
            __errors: []
          },
          {
            testlist_step_id: 4150,
            testlist_id: 903,
            type: "with_evidence",
            text: "2.1\tMake a list with the requirements applied to the previous point",
            position: 2,
            create_time: "2021-07-28 11:27:17",
            __errors: []
          }
        ]
      },
      {
        testlist_id: 273,
        name: "1.1.1. System Architecture ",
        jurisdiction: 'Malta',
        estimated_time: 60,
        test_procedure: "The System's architecture is exactly as indicated in the application submission.",
        create_time: "2020-03-19 08:06:50",
        __errors: [],
        testlistJoinRegulationList:
        {
          testlist_id: 273,
          checklist_id: 20,
          regulation_id: 340,
          __errors: [],
          checklist: {
            checklist_id: 20,
            jurisdiction_id: 2,
            name: "Checklist MT - System Audit - Rev2",
            details: "MGA System Audit",
            create_time: "2020-03-18 18:08:33",
            __errors: [],
            checklistJoinRegulationList: [
              {
                checklist_id: 20,
                regulation_id: 340,
                __errors: [],
                regulation: {
                  regulation_id: 340,
                  jurisdiction_id: 2,
                  law_id: 6,
                  article_title: "1.1.1. System Architecture ",
                  article_details: "The System's architecture is exactly as indicated in the application submission.",
                  create_time: "2020-03-18 09:26:05",
                  __errors: [],
                  categoryList: [
                    {
                      category_id: 58,
                      code: "MT System Audit",
                      name: "MT System Audit",
                      create_time: "2020-03-18 07:52:52",
                      __errors: []
                    }
                  ]
                }
              },
            ]
          },
          regulation: {
            regulation_id: 340,
            jurisdiction_id: 2,
            law_id: 6,
            article_title: "1.1.1. System Architecture ",
            article_details: "The System's architecture is exactly as indicated in the application submission.",
            create_time: "2020-03-18 09:26:05",
            __errors: [],
            categoryList: [
              {
                category_id: 58,
                code: "MT System Audit",
                name: "MT System Audit",
                create_time: "2020-03-18 07:52:52",
                __errors: []
              }
            ]
          }
        }
        ,
        testlistStepList: [
          {
            testlist_step_id: 272,
            testlist_id: 273,
            type: "without_evidence",
            text: "The System's architecture is exactly as indicated in the application submission.",
            position: 1,
            create_time: "2020-04-07 23:15:47",
            __errors: []
          },
          {
            testlist_step_id: 1316,
            testlist_id: 273,
            type: "with_evidence",
            text: "Requirements:\n-Documentation - Achitecture check\nVerification:\nThe version presented to the regulator must coincide with the implemented one. Carry out a verification of the different components of the architecture and that the declared functionalities are implemented.",
            position: 1,
            create_time: "2020-05-14 10:02:03",
            __errors: []
          }
        ]
      }
    ]
  }


  private jurisdictionsSubject = new BehaviorSubject<string[]>([]);
  public jurisdictions$ = this.jurisdictionsSubject.asObservable();

  private lawsSubject = new BehaviorSubject<string[]>([]);
  public laws$ = this.lawsSubject.asObservable();

  private regulationsSubject = new BehaviorSubject<string[]>([]);
  public regulations$ = this.regulationsSubject.asObservable();

  private checklistsSubject = new BehaviorSubject<any[]>([]);
  public checklists$ = this.checklistsSubject.asObservable();

  constructor(
    private jurisdictionsService: JurisdictionsService,
    private lawsService: LawsService,
    private injector: Injector
  ) {

    this.getJurisdictions();

    this.storeService = inject(StoreService);
    this.httpClient = inject(HttpClient);

    this.storeService.getAuthToken().subscribe(
      (data: any) => { this.accessToken = data ? data['accessToken'] : null }
    )

  }


  GET(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.get<any>(url, {
      headers,
      params
    });
  }

  POST(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.post<any>(url, data, {
      headers,
      params
    });
  }

  POSTMULTIPART(url: string, formData: FormData, params?: HttpParams): Observable<any> {
    let headers = new HttpHeaders();
    if (formData instanceof FormData) {
      if (this.accessToken) {
        headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
      }
      return this.httpClient.post<any>(url, formData, {
        headers,
        params,
      });
    }

    return of({ error: 'Invalid FormData object provided' });
  }

  PUTMULTIPART(url: string, formData: FormData, params?: HttpParams): Observable<any> {
    let headers = new HttpHeaders();
    if (formData instanceof FormData) {
      if (this.accessToken) {
        headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
      }
      return this.httpClient.put<any>(url, formData, {
        headers,
        params,
      });
    }

    return of({ error: 'Invalid FormData object provided' });
  }


  PUT(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };

    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.put<any>(url, data, {
      headers,
      params
    });
  }

  DELETE(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.delete<any>(url, {
      headers,
      params
    });
  }
  getUrl(path: string): string {
    return `${environment.apiBaseUrl}${path}`
  }


  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(projectId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}`), data);
  }

  delete(projectId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}`));
  }

  optionsJurisdictions(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/options/jurisdictions`), options?.params);
  }

  listProjectInspectors(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-user-accesses`), options?.params);
  }

  optionsProjectInspectors(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-user-accesses/available-users`), options?.params);
  }

  createProjectInspectors(data: any, projectId: number): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-user-accesses`), data);
  }

  updateProjectInspectors(projectId: number, projectUserAccessesId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-user-accesses/${projectUserAccessesId}`), data);
  }

  deleteProjectInspectors(projectId: number, projectUserAccessesId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-user-accesses/${projectUserAccessesId}`));
  }






  listSettings(options?: ApiOptionsConfig): Observable<any> {
    const response = {
      status: {
        code: 200,
        description: "OK",
        timestamp: new Date().toISOString(),
        trace: "67ab61fa86fa199e4b87104e49f9e3a0",
        span: "9c9192726658a369"
      },
      data: {
        projectSettings: this.projectSettings
      },
      pagination: {
        page: 0,
        pageSize: 25,
        pageItemCount: 2,
        totalCount: 2,
        totalPages: 1
      }
    };
    return of(response).pipe(delay(500));
  }


  listProjectsItems(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-items`), options?.params);
  }

  detailProjectsItems(projectId: number, itemId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-items/${itemId}`), options?.params);
  }

  createProjectsItems(data: any, projectId: number): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-items`), data);
  }

  updateProjectsItems(projectId: number, itemId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-items/${itemId}`), data);
  }

  deleteProjectsItems(projectId: number, itemId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-items/${itemId}`));
  }




  listDocumentsRequestedToClient(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-customer-documents`), options?.params);
  }

  detailDocumentRequestedToClient(projectId: number, documentId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-customer-documents/${documentId}`), options?.params);
  }

  createDocumentRequestedToClient(projectId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${projectId}/project-customer-documents`), formData);
  }

  updateDocumentRequestedToClient(projectId: number, documentId: number, data: any): Observable<any> {
    return this.PUTMULTIPART(this.getUrl(`${BASE_URL}/${projectId}/project-customer-documents/${documentId}`), data);
  }

  sendDocumentRequestedToClient(projectId: number): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-customer-documents/send-request-to-client`), null);
  }

  deleteDocumentRequestedToClient(projectId: number, documentId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-customer-documents/${documentId}`));
  }




  listProjectDocuments(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-documents`), options?.params);
  }

  detailProjectDocument(projectId: number, documentId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-documents/${documentId}`), options?.params);
  }

  createProjectDocument(projectId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${projectId}/project-documents`), formData);
  }

  updateProjectDocument(projectId: number, documentId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-documents/${documentId}`), data);
  }

  deleteProjectDocument(projectId: number, documentId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-documents/${documentId}`));
  }


  listProjectTeams(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-teams`), options?.params);
  }

  availableProjectTeams(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-teams/available-staff`), options?.params);
  }

  detailProjectTeams(projectId: number, teamId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-teams/${teamId}`), options?.params);
  }

  createProjectTeams(data: any, projectId: number): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-teams`), data);
  }

  updateProjectTeams(projectId: number, teamId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-teams/${teamId}`), data);
  }

  deleteProjectTeams(projectId: number, teamId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-teams/${teamId}`));
  }

  sendProjectTeamApproval(projectId: number): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-teams/send-approval-to-client`), {});
  }

  listProjectTeamConfilts(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/team-conflicts`), options?.params);
  }

  updateProjectTeamConfilts(projectId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/team-conflicts`), data);
  }



  listProjectsWorkingLists(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-workinglists`), options?.params);
  }

  createProjectsWorkingListsFromItemsToTest(projectId: number, projectItemId: number, data: any,): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-workinglists/create-from-project-item/${projectItemId}`), data);
  }

  updateProjectsWorkingLists(projectId: number, projectWorkinglistId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-workinglists/${projectWorkinglistId}`), data);
  }

  detailProjectsWorkingLists(projectId: number, projectWorkinglistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-workinglists/${projectWorkinglistId}`), options?.params);
  }

  deleteProjectsWorkingLists(projectId: number, projectWorkinglistId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-workinglists/${projectWorkinglistId}`));
  }

  listProjectChecklists(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-checklists`), options?.params);
  }

  detailProjectChecklist(projectId: number, checklistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-checklists/${checklistId}`), options?.params);
  }

  updateProjectChecklist(projectId: number, checklistId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-checklists/${checklistId}`), data);
  }

  deleteProjectChecklist(projectId: number, checklistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-checklists/${checklistId}`), options?.params);
  }

  createProjectChecklistFromWorkingList(projectId: number, projectWorkinglistId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-checklists/create-from-project-workinglist/${projectWorkinglistId}`), data);
  }

  listProjectTestlistsRules(projectId: number, projectTestlistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/regulations`), options?.params);
  }

  listProjectTestlists(projectId: number, projectChecklistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/checklists/${projectChecklistId}`), options?.params);
  }

  detailProjectTestlist(projectId: number, testlistId: number, options?: ApiOptionsConfig): Observable<any> {
    const testlist = this.projectSettings.testlists.find(t => t.testlist_id === testlistId);
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${testlistId}`), options?.params);
  }

  listProjectTestProcedure(projectId: number, projectChecklistId: number, testlistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/checklists/${projectChecklistId}/${testlistId}`), options?.params);
  }

  updateProjectTestlistReviewStatus(projectId: number, projectTestlistId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}`), data);
  }

  listProjectTestlistStatusRounds(projectId: number, projectBatchId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${projectBatchId}/project-rounds/grouped-info`), options?.params);
  }

  updateProjectTestlistStatusRounds(projectId: number, projectBatchId: number, nextStatus: string, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${projectBatchId}/project-rounds/next-status/${nextStatus}`), data);
  }

  listProjectTestlistEvidences(projectId: number, projectTestlistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/evidences`), options?.params);
  }

  createProjectTestListEvidences(projectId: number, projectTestlistId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/evidences`), formData);
  }

  deleteProjectTestListEvidences(projectId: number, projectTestlistId: number, attachmentId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/evidences/${attachmentId}`));
  }

  createProjectTestlistFromCheckList(projectId: number, projectChecklistId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/create-from-project-checklist/${projectChecklistId}`), data);
  }

  listProjectTestListSteps(projectId: number, projectTestlistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/steps`), options?.params);
  }

  createProjectTestListSteps(projectId: number, projectTestlistId: number, projectTestlistStepId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/steps/${projectTestlistStepId}/evidences`), formData);
  }

  updateProjectTestListSteps(projectId: number, projectTestlistId: number, projectTestlistStepId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/steps/${projectTestlistStepId}`), data);
  }

  deleteProjectTestListSteps(projectId: number, projectTestlistId: number, projectTestlistStepId: number, attachmentId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/steps/${projectTestlistStepId}/evidences/${attachmentId}`));
  }

  listProjectTestlistChecklistCloneIssue(projectId: number, projectTestlistId: number, projectTestlistStepId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/steps/${projectTestlistStepId}/clone-candidates`), options?.params);
  }

  createProjectTestlistChecklistCloneIssue(projectId: number, projectTestlistId: number, projectTestlistStepId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${projectTestlistId}/steps/${projectTestlistStepId}/clone-issue`), data);
  }

  listProjectIssues(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-issues`), options?.params);
  }

  createProjectIssue(projectId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-issues`), data);
  }

  updateProjectIssue(projectId: number, projectIssueId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}`), data);
  }

  detailProjectIssue(projectId: number, projectIssueId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}`), options?.params);
  }

  deleteProjectIssue(projectId: number, projectIssueId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}`));
  }

  listProjectIssuesEvidences(projectId: number, projectIssueId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}/evidences`), options?.params);
  }

  createProjectIssuesEvidences(projectId: number, projectIssueId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}/evidences`), formData);
  }

  deleteProjectIssuesEvidences(projectId: number, projectIssueId: number, attachmentId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}/evidences/${attachmentId}`));
  }

  getProjectIssuesExcel(projectId: number): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-issues/excel`));
  }

  listProjectIssuesNotes(projectId: number, projectIssueId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}/notes`), options?.params);
  }

  createProjectIssuesNotes(projectId: number, projectIssueId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}/notes`), data);
  }

  deleteProjectIssuesNotes(projectId: number, projectIssueId: number, sectionNoteId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-issues/${projectIssueId}/notes/${sectionNoteId}`));
  }



  listProjectCertificate(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-certificates`), options?.params);
  }

  detailProjectCertificate(projectId: number, certificateId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-certificates/${certificateId}`), options?.params);
  }

  createProjectCertificate(projectId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${projectId}/project-certificates`), formData);
  }

  updateProjectCertificate(projectId: number, certificateId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-certificates/${certificateId}`), data);
  }

  deleteProjectCertificate(projectId: number, certificateId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-certificates/${certificateId}`));
  }



  listProjectContractsAndDocs(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-contracts`), options?.params);
  }

  detailProjectContractsAndDocs(projectId: number, contractId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-contracts/${contractId}`), options?.params);
  }

  createProjectContractAndDocs(projectId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${projectId}/project-contracts`), formData);
  }

  updateProjectContractAndDocs(projectId: number, contractId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-contracts/${contractId}`), data);
  }

  deleteProjectContractAndDocs(projectId: number, contractId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-contracts/${contractId}`));
  }



  listProjectBatch(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-batches`), options?.params);
  }

  detailProjectBatch(projectId: number, batchId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${batchId}`), options?.params);
  }

  createProjectBatch(projectId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-batches`), data);
  }

  updateProjectBatch(projectId: number, batchId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${batchId}`), data);
  }

  deleteProjectBatch(projectId: number, batchId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${batchId}`));
  }


  listProjectBatchChecklist(projectId: number, projectBatchId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${projectBatchId}/checklists`), options?.params);
  }

  listProjectBatchChecklistAvailable(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-batches/available-checklists`), options?.params);
  }

  detailProjectBatchChecklist(projectId: number, projectBatchId: number, projectBatchChecklistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${projectBatchId}/checklists/${projectBatchChecklistId}`), options?.params);
  }

  createProjectBatchChecklist(projectId: number, projectBatchId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${projectBatchId}/checklists`), data);
  }

  deleteProjectBatchChecklist(projectId: number, projectBatchId: number, projectBatchChecklistId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-batches/${projectBatchId}/checklists/${projectBatchChecklistId}`));
  }




  /*************
   ** START SETTINGS API METHODS **
   ************/


  listSettingsChecklist(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL_CHECKLIST), options?.params);
  }

  detailSettingsChecklist(checklistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_CHECKLIST}/${checklistId}`), options?.params);
  }

  createSettingsChecklist(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL_CHECKLIST), data);
  }

  updateSettingsChecklist(checklistId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL_CHECKLIST}/${checklistId}`), data);
  }

  deleteSettingsChecklist(checklistId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL_CHECKLIST}/${checklistId}`));
  }

  listSettingsRegulationToChecklist(checklistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_CHECKLIST}/${checklistId}/regulations`), options?.params);
  }

  updateSettingsRegulationToChecklist(checklistId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL_CHECKLIST}/${checklistId}/regulations`), data);
  }

  listSettingsRegulationToChecklistChangelog(checklistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_CHECKLIST}/${checklistId}/audit-logs`), options?.params);
  }

  listSettingsTestlist(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL_TESTLIST), options?.params);
  }

  detailSettingsTestlist(testlistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_TESTLIST}/${testlistId}`), options?.params);
  }

  createSettingsTestlist(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL_TESTLIST), data);
  }

  updateSettingsTestlist(testlistId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL_TESTLIST}/${testlistId}`), data);
  }

  deleteSettingsTestlist(testlistId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL_TESTLIST}/${testlistId}`));
  }

  listSettingsRegulationToTestlist(testlistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_TESTLIST}/${testlistId}/regulations`), options?.params);
  }
  updateSettingsRegulationToTestlist(testlistId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL_TESTLIST}/${testlistId}/regulations`), data);
  }

  listSettingsRegulationToTestlistSteps(testlistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_TESTLIST}/${testlistId}/steps`), options?.params);
  }

  createSettingsRegulationToTestlistSteps(testlistId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL_TESTLIST}/${testlistId}/steps`), data);
  }

  listSettingsRegulationToTestlistChangelog(testlistId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_TESTLIST}/${testlistId}/audit-logs`), options?.params);
  }

  listSettingsChecklistGroup(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL_CHECKLIST_GROUP), options?.params);
  }

  detailSettingsChecklistGroup(checklistGroupId: number | string, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_CHECKLIST_GROUP}/${checklistGroupId}`), options?.params);
  }

  createSettingsChecklistGroup(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL_CHECKLIST_GROUP), data);
  }

  updateSettingsChecklistGroup(checklistGroupId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL_CHECKLIST_GROUP}/${checklistGroupId}`), data);
  }

  deleteSettingsChecklistGroup(checklistGroupId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL_CHECKLIST_GROUP}/${checklistGroupId}`));
  }

  /*************
   ** END SETTINGS API METHODS **
   ************/


  getChecklistsByJurisdictionAndLaw(jurisdiction: number, law: number): Observable<any[]> {
    let queryParams = new HttpParams()
      .set('size', '9999')
      .set('jurisdictionId', jurisdiction.toString())
      .set('lawId', law.toString());

    return this.listSettingsChecklist({ params: queryParams }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.checklist) {
          return response.data.checklist.map((checklist: any) => ({
            key: checklist.checklistId,
            value: checklist.name
          }));
        }
        return [];
      })
    );
  }

  getLawsByJurisdiction(jurisdiction: string): Observable<{ key: string; value: string }[]> {
    return this.laws$.pipe(
      map((allLaws: any[]) => {

        if (!allLaws || allLaws.length === 0) {
          return [];
        }

        const filteredLaws = allLaws.filter((law: any) => {
          if (!law || !law.jurisdiction) {
            console.warn('Service - Law without jurisdiction data:', law);
            return false;
          }

          return law.jurisdiction.jurisdictionId == jurisdiction;
        });


        const mappedLaws = filteredLaws.map((law: any) => ({
          key: law.lawId,
          value: law.name
        }));


        return mappedLaws;
      })
    );
  }

  getJurisdictions() {
    this.jurisdictionsService.list({ params }).subscribe({
      next: (response: any) => {
        const updatedJurisdictions = response.data.jurisdictions;
        this.jurisdictionsSubject.next(updatedJurisdictions);
      },
      error: (error: any) => {
        console.error('Error fetching jurisdictions:', error);
      }
    });
  }


  getLaws() {
    this.lawsService.list({ params }).subscribe({
      next: (response: any) => {

        let updatedLaws;
        if (response && response.data && response.data.laws) {
          updatedLaws = response.data.laws;
        } else if (Array.isArray(response)) {
          updatedLaws = response;
        } else {
          console.warn('Service - Unexpected response format for laws:', response);
          updatedLaws = [];
        }


        this.lawsSubject.next(updatedLaws);
      },
      error: (error: any) => {
        console.error('Service - Error fetching laws:', error);
        this.lawsSubject.next([]);
      }
    });
  }

  getChecklists(filters?: { jurisdictionId?: number; lawId?: number }) {

    let queryParams = new HttpParams().set('size', '9999');

    if (filters) {
      if (filters.jurisdictionId !== undefined) {
        queryParams = queryParams.set('jurisdictionId', filters.jurisdictionId.toString());
      }

      if (filters.lawId !== undefined) {
        queryParams = queryParams.set('lawId', filters.lawId.toString());
      }
    }

    this.listSettingsChecklist({ params: queryParams }).subscribe({
      next: (response: any) => {
        const updatedChecklists = response.data.checklist;
        this.checklistsSubject.next(updatedChecklists);
      },
      error: (error: any) => {
        console.error('Error fetching checklists with filters:', filters, error);
      }
    });
  }

  getRegulationList(customParams?: HttpParams): Observable<any> {


    const regulationsService = this.injector.get(RegulationsService);

    const options = customParams
      ? { params: customParams }
      : undefined;

    regulationsService.list(options).subscribe({
      next: (response: any) => {
        let updatedRegulation;
        if (response && response.data && response.data.regulations) {
          updatedRegulation = response.data.regulations;
        } else if (Array.isArray(response)) {
          updatedRegulation = response;
        } else {
          console.warn('Unexpected response format for regulations:', response);
          updatedRegulation = [];
        }

        this.regulationsSubject.next(updatedRegulation);
      },
      error: (error: any) => {
        console.error('Error fetching regulations:', error);
        this.regulationsSubject.next([]);
      }
    });

    return this.regulations$;
  }

  listSummaryNotes(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/notes`), options?.params);
  }

  createSummaryNotes(projectId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/notes`), data);
  }

  deleteSummaryNotes(projectId: number, sectionNoteId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/notes/${sectionNoteId}`));
  }

  listHistoryLogs(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/history`), options?.params);
  }

  listTestlistNotes(projectId: number, macroTestId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${macroTestId}/notes`), options?.params);
  }

  createTestlistNotes(projectId: number, macroTestId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${macroTestId}/notes`), data);
  }

  deleteTestlistNotes(projectId: number, macroTestId: number, sectionNoteId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${projectId}/project-testlists/${macroTestId}/notes/${sectionNoteId}`));
  }

  private mockTestStepLogsMap: { [stepId: number]: any[] } = {};

  private mockTestStepLogsDefault: any[] = [
    {
      author: 'Rossi Mario',
      dateTime: '2024-10-15T09:30:00Z',
      status: 'PASSED'
    },
    {
      author: 'Bianchi Luca',
      dateTime: '2024-09-20T14:15:00Z',
      status: 'FAILED'
    },
    {
      author: 'Verdi Anna',
      dateTime: '2024-09-05T11:45:00Z',
      status: 'SKIPPED'
    }
  ];

  getTestStepLogs(projectTestlistStepId: number): Observable<any> {
    const logs = this.mockTestStepLogsMap[projectTestlistStepId] ?? this.mockTestStepLogsDefault;
    return of({
      status: { code: 200, description: 'OK' },
      data: { logs }
    }).pipe(delay(300));
  }

}
